import React from "react";
import ExpenseDetailPage from "../Detail";

interface Props {
  overridePropertyId?: string;
  embedded?: boolean;
}

/** /expenses/new のラッパー: Detail ページを new モードで描画 */
const ExpenseCreatePage: React.FC<Props> = ({ overridePropertyId, embedded }) => (
  <ExpenseDetailPage
    mode="new"
    overridePropertyId={overridePropertyId}
    embedded={embedded}
  />
);

export default ExpenseCreatePage;
